import React, { Component } from 'react'
import { addToCard, checkTranslation, imageAddress, priceStandardView, translate } from '../../utils/useful'
import FixedView from '../../components/FixedView'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import CustomLoader from '../../components/CustomLoader';


export class ShoppingCartMenu extends Component {

    state = {
        isLoading: {}
    }


    openFixedView = () => {
        this.fixedView.showView()
    }

    // addToCart = (changeCount, products) => {
    //     this.props.addToCart(changeCount, products)
    // }

    addToCart = (action, count, item, index) => {
        let applet = this.props.variables?.appletId
        let hub = this.props.variables?.targetHub

        let variants = item.variants
        let additionals = item.additionals
        let isLoading = this.state.isLoading
        isLoading[index] = true
        let product = typeof item.product == 'object' ? item.product?._id : item.product
        this.setState({ isLoading })
        addToCard(applet, hub.product, action, count, variants, additionals, () => {
            delete isLoading[index]
            this.setState({ isLoading })

        })
    }






    goToCart = () => {
        this.props.functionsHandler(null, 'changePage', ['cart'])
        this.fixedView.hideView()

    }


    goToProduct = (props) => {
        this.fixedView.hideView()
        this.props.changePage(['product', props.product._id])
    }

    render() {

        let colors = this.props.colors
        let cart = this.props.carts
        if (this.props.carts?.applets && this.props.variables?.appletId) {
            cart = this.props.carts.applets[this.props.variables?.appletId]
        }
        // console.log(this.props.carts)

        let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`


        return (
            <div>
                <button ref={el => this.firstCurrentNode = el} className='mld-2 flexcc dark-blur-hover p-1 br-5 flexc position-relative' onClick={() => this.openFixedView()}>
                    <img className={(colors?.iconInvert ? 'invert' : '')} width={24} src="/assets/icons/cart-white.svg" alt="" />
                    {(cart?.totalCount > 0) && (
                        <div className="position-absolute px-1 flexcc" style={{ zIndex: 1, background: '#FF3B30', color: '#fff', borderRadius: 20, top: -5, right: -5, height: 16, minWidth: 16 }}>
                            <p className="text-smaller white">{cart?.totalCount}</p>
                        </div>
                    )}
                </button>
                <FixedView ref={el => this.fixedView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={0} xOffset={290} zIndex={10} >
                    <div className='w-100'>
                        <div className='d-flex flex-column br-10   scroll-no-scrollbar' style={{ overflowY: "scroll", width: "320px", maxHeight: "400px", backgroundColor: "#fff", boxShadow: '0px 0px 30px #10101070' }}>
                            <div className='px-3 pt-2 pb-2' style={{ borderBottom: '1px solid #eee' }}>
                                <p className='text-bold text-normal'>Shopping cart</p>
                            </div>

                            {Array.isArray(cart?.items) && cart?.items.length > 0 ? (
                                <div className='p-2'>
                                    {cart?.items.map((props, index) => {
                                        return (
                                            <div className='flexcb px-2 py-2 mb-2 bb-gray'>
                                                <div className='w-100'>
                                                    <div className='d-flex'>
                                                        <div>
                                                            <img width={70} className='br-5' height={70} style={{ objectFit: 'cover' }} src={imageAddress(props.product?.media)} />
                                                        </div>
                                                        <div className='mld-2'>
                                                            <button onClick={() => this.goToProduct(props)}>
                                                                <p className='font-size-14 weight-600  mld-1 mb-1'>{checkTranslation(props.product?.name)}</p>
                                                            </button>
                                                            {props?.variants && (
                                                                <div className='w-100'>
                                                                    {Object.entries(props?.variants)?.map(([key, value]) => {
                                                                        return (
                                                                            <p className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}><span className='font-size-13 weight-500'>{key}:</span> {value}</p>
                                                                        )
                                                                    })}
                                                                </div>
                                                            )}

                                                            {typeof props?.additionals == 'object' && (
                                                                <div className='w-100'>
                                                                    {Object.entries(props?.additionals)?.map(([key, value]) => {
                                                                        return (
                                                                            <div>
                                                                                <span className='font-size-13 weight-500 main-c7 mld-1' style={{ textTransform: 'capitalize' }}>{key}:
                                                                                    {typeof value == 'object' && Object.entries(value)?.map(([optionKey, optionValue], oindex) => {
                                                                                        return (
                                                                                            <span>
                                                                                                {optionKey == 'text' ? (
                                                                                                    <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}> {optionValue?.value}</span>

                                                                                                ) : (
                                                                                                    <>
                                                                                                        <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'caspanitalize' }}>{optionKey}
                                                                                                            {optionValue?.priceDifference && (
                                                                                                                <span className='font-size-12 weight-400 main-c7 mld-1'>
                                                                                                                    ({(optionValue?.value != true && optionValue?.value > 1) ? (optionValue?.value + "*" + optionValue?.priceDifference) : ("$" + optionValue?.priceDifference)})
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </span>

                                                                                                    </>
                                                                                                )}
                                                                                                {(oindex < (Object.entries(value).length - 1)) && (
                                                                                                    <span className='mld-1'>,</span>
                                                                                                )}
                                                                                            </span>
                                                                                        )
                                                                                    })}
                                                                                </span>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                    <div className='flexcb w-100 mt-2' >
                                                        <div className=''>
                                                            <div className='flexc'>
                                                                <p className='font-size-14 weight-700 main-c4 '>${priceStandardView(props.amounts?.final)}</p>

                                                                {(props.amounts?.final != props.amounts?.base) && (
                                                                    <p className='font-size-12 main-c4 text-lined mld-2'>${priceStandardView(props.amounts?.base)}</p>
                                                                )}
                                                                {(props?.price?.onSale && !props.additionalsPrice) && (
                                                                    <p className='font-size-12 mld-2  px-2 br-30' style={{ color: '#fff', backgroundColor: "rgb(204, 12, 57)" }}>{props.product?.price?.discount?.value}{props.product?.price?.discount?.unit ?? '%'}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className='flexcb br-30 p-1 ' style={{ border: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
                                                            <button onClick={() => this.addToCart('subtract', 1, props, index)} className='br-30'>
                                                                <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/minimize.svg' />
                                                            </button>
                                                            <div className='px-3 position-relative'>
                                                                {this.state.isLoading[index] && (
                                                                    <div className='w-100 flexcc' style={{ position: 'absolute', top: 6, left: 0 }}>
                                                                        <CustomLoader isLoading={true} type={'ThreeDots'} color={'#444'} height={10} />
                                                                    </div>
                                                                )}

                                                                <p className='main-c4 weight-700' style={{ color: this.state.isLoading[index] ? 'transparent' : null }}>{props.count}</p>

                                                            </div>
                                                            <button onClick={() => this.addToCart("add", 1, props, index)} className='br-30'>
                                                                <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/plus.svg' />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            ) : (
                                <div className='flexcc flex-column p-5'>
                                    <img width={60} src='/assets/icons/empty-cart.svg' />
                                    <p className='mt-4 main-c3'>Your Cart is Empty</p>
                                    <p className='mt-1 main-c7 font-size-10'>Add Product into your cart to purchase them.</p>
                                </div>
                            )}
                            {(cart?.items?.length > 0) && (
                                <div className='position-sticky bottom-0 w-100 p-2 ' style={{ backgroundColor: "#f6f6f6", borderTop: "1px solid #eee" }}>
                                    <div className='flexcb'>
                                        <button className='buy-btn py-2 px-3 br-5' style={{ background: background ?? '#007aff' }} onClick={() => this.goToCart()}>
                                            <p className='font-size-12 text-bold'>{translate('Check out')}</p>
                                        </button>
                                        <div className='text-end mrd-2'>
                                            <p className='font-size-12 text-semibold'>{translate('Items total price')}</p>
                                            <div className='flexce'>
                                                {cart.amounts?.items?.discount > 0 && (
                                                    <p className='font-size-12 text-lined  mrd-2'>${cart.amounts?.items?.base.toFixed(2)}</p>
                                                )}
                                                <p className='font-size-15  weight-700'>${cart.amounts?.items?.final ? cart.amounts?.items?.final.toFixed(2) : 0}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, carts: state.carts })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShoppingCartMenu);